import HttpClientToken from '../../services/HttpClientToken';

import { CiudadProps, defaultCiudad, ObtenerCiudadesParams } from '../../interfaces/catalogos/CiudadInterface';

export const Ciudades = () => {

    return new Promise<CiudadProps[]>( ( resolve ) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.get('/Api/Ciudad/', token)
            .then( ({ data } : { data : CiudadProps[] } ) => {
                resolve( data );
            })
            .catch( () => {
                resolve( [] );
            });

        }

    });

}

export const ObtenerCiudad = ( params: ObtenerCiudadesParams ) => {

    return new Promise<CiudadProps[]>( ( resolve ) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.post('/Api/Ciudad/ObtenerCiudades', params, token)
            .then( ({ data } : { data : CiudadProps[] } ) => {
                resolve( data );
            })
            .catch( () => {
                resolve( [] );
            });

        }

    });

}

export const ActualizarCiudad = ( params: CiudadProps ) => {

    return new Promise<CiudadProps>( ( resolve ) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.post('/Api/Ciudad/Actualizar', params, token)
            .then( ({ data } : { data : CiudadProps} ) => {
                resolve( data );
            })
            .catch( () => {
                resolve( { ...defaultCiudad } );
            });

        }

    });

}

export const AgregarCiudad = ( params: CiudadProps ) => {

    return new Promise<CiudadProps>( ( resolve ) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.post('/Api/Ciudad/Agregar', params, token)
            .then( ({ data } : { data : CiudadProps} ) => {
                resolve( data );
            })
            .catch( () => {
                resolve( { ...defaultCiudad } );
            });

        }

    });

}
